import '../bower_components/select2/select2.css';
import '../bower_components/flag-icon-css/css/flag-icon.min.css';
import '../bower_components/ng-ckeditor/ng-ckeditor.css';
import '../bower_components/jquery-timepicker-jt/jquery.timepicker.css';
import '../bower_components/mjolnic-bootstrap-colorpicker/dist/css/bootstrap-colorpicker.min.css';

import '../upsales/common/components/ui/rangeInput/multirange.css';

import '../styles/bootstrap.scss';
import '../styles/main.scss';
import '../styles/wysiwyg.scss';
import '../styles/custom-ckeditor.css';
